export default __webpack_public_path__ + "static/redStone-eb8903a1a0c737adb77877003783bd5a.svg";